<div class="container">
  <div class="text">
    <app-dialog-input-title
      title="Velkommen til kursusportalen"
    ></app-dialog-input-title>
    <p>
      Her kan du registrere de kurser, som du har gennemført samt uploade
      beviser og certifikater.
    </p>
    <p>
      Hvis du har været på et kursus, som ikke fremgår af listen, bedes du
      informere HR Kursus på
      <a target="_blank" href="mailto:kursus-kruger@veolia.com"
        >kursus-kruger&#64;veolia.com</a
      >, som opretter kurset.
    </p>
    <p>God fornøjelse.</p>
  </div>
  <div class="links">
    <app-dialog-input-title
      title="Yderligere information:"
    ></app-dialog-input-title>
    <a
      target="_blank"
      href="https://drive.google.com/file/d/1VnoVVNz72EMD46oYFGhEwRkX3lSKi6Jy/view?usp=sharing"
    >
      Formål, brugerrettigheder og support
    </a>
    <a
      target="_blank"
      href="https://drive.google.com/file/d/16OEar5PrWs0F-BQcdVjCrWNZpLc8qNlp/view"
    >
      Vejledning til portalen
    </a>
  </div>
</div>
